import React, { useEffect, useRef, useState } from 'react';
import {
    Box, Typography, List, ListItem, Collapse, Button, Popover,
    Checkbox, TextField, InputAdornment,
    styled,
    alpha
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { listItemCategorymaster } from '../../graphql';
import { API, graphqlOperation } from 'aws-amplify';
import { ArrowRight, BuildCircle, Circle, Remove } from '@mui/icons-material';
import AddCategory from '../modals/AddCategory';
import DeleteCategoryModal from "../modals/DeleteCategoryModal";
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import { SimpleTreeView, TreeItem, treeItemClasses } from '@mui/x-tree-view';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../snackBar/snakbar';
import { useThemes } from '../../components/Theme/theme';
import { useListItemCategorymasterQuery } from '../../redux/apis/itemCategory.api';

const CustomEndIcon = styled(Remove)(({ theme }) => ({
    color: theme.palette.primary.main, // Customize color
    fontSize: '20px !important',
    // fontSize: '13px !important',                  // Customize size
}));
const CustomExpandIcon = styled(ArrowRight)(({ theme }) => ({
    color: theme.palette.primary.main, // Customize color
    fontSize: '25px !important',                  // Customize size
}));
const CustomCollapseIcon = styled(ArrowDropDownIcon)(({ theme }) => ({
    color: theme.palette.primary.main, // Customize color
    fontSize: '25px !important',                  // Customize size
}));
const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
    [`& .${treeItemClasses.content}`]: {
        display: "flex",
        alignItems: "center",
        height: "40px",
        // border: "1px solid #ffffff",
        position: "relative",
        "&:before": {
            content: '""',
            position: "absolute",
            left: -10,
            bottom: "50%",
            transform: "translateY(50%)",
            width: 10,
            // borderBottom: `2px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
        },
    },
    [`& .${treeItemClasses.groupTransition}`]: {
        marginTop: -8,
        marginLeft: 13,
        paddingLeft: 8,
        // borderLeft: `2px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
        position: "relative",
    },
    [`& .${treeItemClasses.root}`]: {
        "&:last-child .${treeItemClasses.groupTransition}": {
            borderLeft: "none",
        },
    },
    [`& .singleChild .${treeItemClasses.groupTransition}`]: {
        "&:before": {
            content: '""',
            position: "absolute",
            left: -8,
            top: -12,
            height: 12,
            // borderLeft: `2px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
        },
    },
    // [`& .${treeItemClasses.iconContainer} .MuiSvgIcon-root`]: {
    //     fontSize: "2rem",
    //     color: theme.palette.primary.main,
    // },

    // [`& .${treeItemClasses.iconContainer} > .MuiTreeItem-iconContainer .MuiSvgIcon-root`]:
    // {
    //     fontSize: "2rem !important",
    // },

    // [`& .${treeItemClasses.endIcon} .MuiSvgIcon-root`]: {
    //     width: 10,
    //     height: 10,
    // },
}));

const RecursiveListItem = ({ edit, item, searchTerm, onCheck, checked, setExpandIds }) => {
    const [open, setOpen] = useState(true);
    const hasChildren = item.children && item.children.length > 0;
    const label = item.label.toLowerCase();
    const matchesSearch = label.includes(searchTerm.toLowerCase());
    if (searchTerm && !matchesSearch && !hasChildren) {
        return null;
    }

    const handleCheckItems = (event, item, text) => {
        onCheck(event.target.checked ? item.label : '', item, event, text);
    };
    return (
        <>
            <CustomTreeItem
                itemId={item?.value[1]}
                endOfDashedLine={item?.children?.length}
                onKeyDown={(e) => {
                    if (e.key == "Enter") {
                        e.stopPropagation()
                        return handleCheckItems(e, item, "not to close")
                    }
                }}
                label={
                    <Box
                        key={item?.value[1]}
                        sx={{ display: "flex", alignItems: "center", fontSize: "13px" }} >
                        <Checkbox id='test' sx={{ fontSize: "13px", }} checked={checked == item.tagLabel}
                            // disabled={edit ? edit == item.value[1] : false}
                            onClick={(event) => {
                                event.stopPropagation()
                                if (edit ? edit == item.value[1] : false) {
                                    return showWarningSnackbar("Try to select any other category")
                                }
                            }}
                            onChange={(e) => {
                                if (edit ? edit == item.value[1] : false) {
                                    return showWarningSnackbar("Try to select any other category")
                                }
                                handleCheckItems(e, item)
                            }} />
                        <Typography
                            sx={{
                                fontSize: "13px",
                                width: "150px",
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                WebkitLineClamp: 2, // Limits to 2 lines
                                lineHeight: '1.5',  // Adjust based on typography line height
                                maxHeight: '3em',
                                fontWeight: (edit && edit == item.value[1]) ? "600" : "400", color: (edit && edit == item.value[1]) ? "#cccccc" : ""
                            }}
                            onClick={(e) => {
                                e.stopPropagation()
                                if (edit ? edit == item.value[1] : false) {
                                    return showWarningSnackbar("Try to select any other category")
                                }
                                handleCheckItems(e, item)
                            }}
                        >{item.label}</Typography>
                    </Box>}>
                {edit && edit == item.value[1] ? null :
                    item?.children?.map((child) => (
                        <RecursiveListItem
                            key={item.value[1]}
                            item={child}
                            searchTerm={searchTerm}
                            onCheck={onCheck}
                            checked={checked}
                            edit={edit}
                        />
                    ))}
            </CustomTreeItem>
        </>
    );
};

const TreeDropdown = ({ openOnFocus, setMainCategoryId, parentDetails, row, MainParent, setrow, index, params, onChange, setup, label, setCategoryData, disabled, setState, SetPrentId }) => {
    const [deleteCategoryModal, setCategoryDeleteModal] = useState(false);
    const [categoryArr, setCategoryArr] = useState([]);
    const [categoryModal, setCategoryModal] = useState();
    const [dataArr, setDataArr] = useState([]);
    const [prtDetails, setPrtDetails] = useState();
    const [checkedLabel, setCheckedLabel] = useState(MainParent==="GOODS"?"Goods":"Services");
    
    
    let [expandIds, setExpandIds] = useState([])
    const { theme } = useThemes()
    const transformDataForTreeDropdown = (passData) => {
        return passData.map((item) => ({
            value: [item.category, item.itemcategoryid],
            label: item.category,
            tagLabel: item.label,
            children:
                item.children && item.children.length > 0
                    ? transformDataForTreeDropdown(item.children)
                    : undefined,
        }));
    };
    const flattenTree = (tree) => {
        let flat = [];
        tree.forEach((node) => {
            flat.push(node);
            if (node.children && node.children.length) {
                flat = flat.concat(flattenTree(node.children));
            }
        });
        return flat;
    };
    function buildTree1(items, id) {
        // let id = setup === undefined ? Typeid : 0
        let tree = [];
        let childrenOf = {};
        let ItemMap = (res) => {
            return items.filter((e) => e.itemcategoryid == res)
        }
        items = items?.map(item => {
            const parent = items?.filter((e) => (e.itemcategoryid == item.itemcategorygroupid));
            let parent1 = ItemMap(parent[0]?.itemcategorygroupid)
            let parent2
            if (parent1.length !== 0) {
                parent2 = ItemMap(parent1[0].itemcategorygroupid)
            }
            return {
                ...item,
                tagLabel: item.category,
                label: (parent1?.[0]?.category !== undefined) ? `${parent1[0]?.category} > ${parent?.[0].category} > ${item.category}` : parent?.[0]?.category !== undefined ? `${parent[0].category} > ${item.category}` : item.category
            }
        })
        // items = items?.map(item => ({
        //     ...item,
        //     label: item.Category,
        //     tagLabel: item.Category
        // }));
        items?.forEach((item) => {
            childrenOf[item.itemcategoryid] =
                childrenOf[item.itemcategoryid] || [];
            item.children = childrenOf[item.itemcategoryid];
        });
        items?.forEach((item) => {
            if (item.itemcategorygroupid == id || (item.itemcategorygroupid == 0 && setup == "NotNeed")) {
                tree.push(item);
            } else {
                // tree.push(item);
                childrenOf[item.itemcategorygroupid] =
                    childrenOf[item.itemcategorygroupid] || [];
                childrenOf[item.itemcategorygroupid].push(item);
            }
        });
        // if (setup == "NotNeed") {
        let itemMap = new Map();
        let tree1 = [];

        items.forEach(item => {
            item.children = [];
            itemMap.set(item.itemcategoryid, item);
        });
        items.forEach(item => {
            if (item.itemcategorygroupid === 0) {
                tree1.push(item);
            } else {
                const parent = itemMap.get(item.itemcategorygroupid);
                if (parent) {
                    parent.children.push(item);
                }
            }
        });
        tree = tree1
        // }
        sortTree(tree);
        return tree;
    }

    function countDescendants(node) {
        if (!node.children || node.children.length === 0) {
            return 0;
        }
        let count = node.children.length;
        node.children.forEach(child => {
            count += countDescendants(child);
        });
        return count;
    }
    function sortTree(nodes) {
        nodes.forEach(node => {
            node.descendantCount = countDescendants(node);
        });
        nodes.sort((a, b) => b.descendantCount - a.descendantCount);
        nodes.forEach(node => {
            if (node.children && node.children.length > 0) {
                sortTree(node.children);
            }
        });
    }

    // useEffect(() => {
    //     getCategory()
    // }, [params?.row?.ItemType, MainParent])

    const [data, setData] = useState()
    const [nonTreeData, setNonTreeData] = useState()
    let mainCategoryParent = params?.row?.itemtype == "GOODS" ? "Goods" : "Services"
    if (MainParent !== undefined) {
        mainCategoryParent = MainParent == "GOODS" || MainParent == "Goods" ? "Goods" : "Services"
    }
    const {
        data: categoryList,
        isLoading: isCategoryListLoading,
        isError: isCategoryListError,
        isSuccess: CategoryListed
    } = useListItemCategorymasterQuery({ maincategory: mainCategoryParent });
    async function getCategory() {
     
        
        try {
            let mainCategory = params?.row?.itemtype == "GOODS" ? "Goods" : "Services"
            if (MainParent !== undefined) {
                mainCategory = MainParent == "GOODS" || MainParent == "Goods" ? "Goods" : "Services"
            }
            let checkValue = row?.[index]?.category?.[0] === undefined ? "" : row?.[index]?.category?.[0]
            // const res = await API.graphql(graphqlOperation(listItemCategorymaster, { maincategory: mainCategory }));
            // let categoryValues = res.data.listItemCategorymaster;
            let categoryValues = categoryList;
            let MainId
            if (setMainCategoryId && prtDetails == undefined) {
                categoryValues.map((e) => {
                    if (e.category == mainCategory) {
                        setMainCategoryId(e.itemcategoryid)
                        // if (checkedLabel == undefined || checkedLabel == "") {
                            setCheckedLabel(e.category)
                        // }
                        MainId = { id: e.itemcategoryid, name: e.category }
                    }
                })
            }
            // let TypeId = categoryValues[0]?.ItemCategoryID;   
            let TypeId = (categoryValues?.filter((e) => e.category == mainCategory))?.[0].itemcategoryid;
            let CategoryGoodsArr = categoryValues?.filter((e) => e?.maincategory == mainCategory)?.map((ele) => ({
                label: ele?.category,
                value: ele?.itemcategoryid,
                ...ele,
            }));
            let CategorySerArr = categoryValues?.filter((e) => e?.maincategory == mainCategory)?.map((ele) => ({
                label: ele?.category,
                value: ele?.itemcategoryid,
                ...ele,
            }));
            if (setup == "NotNeed") {
                CategoryGoodsArr = categoryValues?.map((ele) => ({
                    label: ele?.category,
                    value: ele?.itemcategoryid,
                    ...ele,
                }));
                CategorySerArr = categoryValues?.map((ele) => ({
                    label: ele?.category,
                    value: ele?.itemcategoryid,
                    ...ele,
                }));
            }
            let ItemType = params?.row?.ItemType
            if (MainParent !== undefined) {
                ItemType = MainParent
            }
            if (SetPrentId) {
                SetPrentId(TypeId)
            }
            let CategoryArr = categoryValues?.map(ele => ({
                label: ele?.category,
                value: ele?.itemcategoryid,
                ...ele,
            }));
            const labelExists = CategoryArr?.some(category => category.value === prtDetails);
            let defValue = CategoryArr?.find((e) => e.label.toLowerCase() === MainParent.toLowerCase())
            if (prtDetails !== undefined && !labelExists) {
                setMainCategoryId(defValue?.value)
                // setState((prev) => ({
                //     ...prev,
                //     itemCtegorey: defValue?.value,
                // }));
              
                
                
                setCheckedLabel(defValue?.label===undefined?(ItemType == "GOODS"?"Goods":"Services"):defValue?.label);
            }
            categoryValues = ItemType !== undefined ? ItemType == "GOODS" ? CategoryGoodsArr : CategorySerArr : categoryValues

            setCategoryArr(CategoryArr);
            setDataArr(buildTree1(categoryValues, TypeId))

            let ItemMap = (res) => {
                return categoryValues.filter((e) => e.itemcategoryid == res)
            }
            let arr = categoryValues.map(item => {
                const parent = categoryValues.filter((e) => (e.itemcategoryid == item.itemcategorygroupid));
                let parent1 = ItemMap(parent[0]?.itemcategorygroupid)
                let parent2
                if (parent1.length !== 0) {
                    parent2 = ItemMap(parent1[0].itemcategorygroupid)
                }
                return {
                    ...item,
                    label: item.category,
                    tagLabel: (parent1?.[0]?.category !== undefined) ? `${parent1[0]?.category} > ${parent?.[0].category} > ${item.category}` : parent?.[0]?.category !== undefined ? `${parent[0].category} > ${item.category}` : item.category
                }
            })
            if (prtDetails !== undefined && labelExists !== false) {
                let a = arr?.find((e) => prtDetails == e.itemcategoryid)
                setCheckedLabel(a?.tagLabel)
            }
            setNonTreeData(arr)
            setData(transformDataForTreeDropdown(buildTree1(arr, TypeId)))
        }
        catch (e) {
            console.log(e, "error")
        }
    }
    useEffect(() => {
        if (CategoryListed) {
            getCategory()
        }
    }, [MainParent, prtDetails, CategoryListed,categoryList])
    useEffect(() => {
        const tree = dataArr;
        function findParentChain(item, allCategories, result = []) {
            result.push(item?.value); // Add the current item's ID

            if (item?.itemcategorygroupid === 0) {
                return result;
            } else {
                const parent = allCategories?.find(cat => cat.itemcategoryid === item?.itemcategorygroupid);

                if (parent) {
                    return findParentChain(parent, allCategories, result);
                } else {
                    return result;
                }
            }
        }
        let item = flattenTree(tree).find((e) => e.label == checkedLabel)
        const parentChain = findParentChain(item, nonTreeData);

        setExpandIds(parentChain)
        return () => {

        }
    }, [checkedLabel])

    const [anchorEl, setAnchorEl] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    function defaultCategory() {
        let category
        categoryArr?.map((e) => {
            if (e.category == e.maincategory) {
                category = e.category
            }
        })
        if ((checkedLabel == "" || checkedLabel == undefined)) {
            setCheckedLabel(category)
        }
    }

    useEffect(() => {
        if (prtDetails == undefined) {
            if (parentDetails == undefined) {
                defaultCategory()
            }
            else {
                // if (parentDetails?.category == undefined && parentDetails !== undefined) {
                let a = nonTreeData?.find((e) => parentDetails == e.itemcategoryid)
                if (parentDetails?.id) {
                    a = nonTreeData?.find((e) => parentDetails.id == e.itemcategoryid)
                    // }
                }
                if (a !== undefined && prtDetails == undefined) {
                    setCheckedLabel(a?.tagLabel)
                }
            }
        }
    }, [categoryArr, parentDetails])

    const handleClick = (event) => {
        if (!disabled) {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value.toLowerCase());
    };

    const handleCheck = (label, item, e, text) => {
        if (checkedLabel == item.label) {
            // setCheckedLabel("");
            if (setrow !== undefined) {
                setrow((prevArray) => {
                    let newArray = [...prevArray];
                    let firstObject = { ...newArray[index] };
                    firstObject.category = ""
                    newArray[index] = firstObject;
                    return newArray;
                });
                params.api.setEditCellValue(
                    {
                        id: params.id,
                        field: params.field,
                        value: "",
                    }, e
                );
            }
            return
        }
        setCheckedLabel(item?.tagLabel);
        if (setrow !== undefined) {
            setrow((prevArray) => {
                let newArray = [...prevArray];
                let firstObject = { ...newArray[index] };
                firstObject.category = searchTerm == "" ? [[item?.value[0]], item?.value] : [[item?.label], [item?.label, item?.value]];
                newArray[index] = firstObject;
                return newArray;
            });
            params.api.setEditCellValue(
                {
                    id: params.id,
                    field: params.field,
                    value: searchTerm == "" ? item.value : [item?.label, item?.value],
                }, e
            );
        }
        else {
            onChange(item)
        }
        setSearchTerm('');
        if (text != "not to close") {
            handleClose();
        }
    };
    const handleCheckItems = (event, item) => {
        handleCheck(event.target.checked ? item.label : '', item, event);
    };

    const openPopover = Boolean(anchorEl);
    const id = openPopover ? 'custom-tree-popover' : undefined;
    const textFieldRef = useRef(null);
    useEffect(() => {
        if (openOnFocus == true && anchorEl == null) {
            if (textFieldRef.current) {
                handleClick({ currentTarget: textFieldRef.current });
            }
        }
        // else {
        //     handleClose()
        // }
    }, [openOnFocus, anchorEl])

    useEffect(() => {
        if (categoryModal == true) {
            handleClose()
        }
        else if (categoryModal == false) {
            handleClick({ currentTarget: textFieldRef.current });
        }
        return () => {
        }
    }, [categoryModal])
    const textfieldInRef = useRef(null);
    useEffect(() => {
        if (openPopover) {
            setTimeout(() => {
                document.getElementById("searchCaegory")?.focus()
                if (textfieldInRef.current) {
                    textfieldInRef.current.focus();
                }
            }, 200);
        }
    }, [openPopover, textfieldInRef]);
    function handleAutoCompleteKeyDown(
        e,
        name,
        currentId,
        nextId,
        required,
        warMsg,
        prevID,
        multiple
    ) {
        const activeDescendantId = e.target.getAttribute("aria-activedescendant");
        const isAutocompleteOpen =
            document.activeElement.getAttribute("aria-expanded") === "true";

        if (e.key === "Tab" && e.shiftKey) {
            e.preventDefault();
            e.stopPropagation();
            const prevElement = document.getElementById(prevID);
            prevElement?.focus();
            return;
        }

        if ((e.key === "Enter" || e.key === "Tab") && !e.shiftKey) {
            if (multiple && e.key === "Enter") {
                return; // Exit without moving focus to next field
            }

            if (
                required &&
                e.target.value === "" &&
                isAutocompleteOpen &&
                !activeDescendantId
            ) {
                e.preventDefault();
                e.stopPropagation();
                showWarningSnackbar(warMsg);
                const currentElement = document.getElementById(currentId);
                currentElement?.focus();
            } else {
                e.preventDefault();
                e.stopPropagation();
                const nextElement = document.getElementById(nextId);
                nextElement?.focus();
            }
        }
    }

    return (
        <div style={{ width: "100%",border:"none !important" }}
            onKeyDown={(e) => {
                if (e.key == "ArrowDown") {
                    handleClick(e)
                }
                if (e.key == "Tab" && !document.activeElement.id == "test") {
                    e.preventDefault()
                    handleClose()
                }
            }}
        >
            <TextField
                tabIndex={0}
                sx={{
                    height: setup !== undefined || label !== undefined ? "34px" : "32px",
                    mt: setup !== undefined || label !== undefined ? "" : "-2px",
                    ml: setup !== undefined || label !== undefined ? "" : "-2px",
                    // "& fieldset": setup !== undefined || label !== undefined ? "" : { border: "none" },
                    "& .MuiOutlinedInput-root.Mui-focused": {
                        border: setup === undefined && label === undefined ? "none !important" : undefined,
                      },
                      "& fieldset": {
                        border: setup === undefined && label === undefined ? "none" : undefined,
                      },
                    width: "100%",
                    "& .MuiInputLabel-root": {
                        color: disabled ? "rgba(0, 0, 0, 0.38)" : "inherit", // Change label color when disabled
                      },
                    '& .MuiInputBase-root': {
                        padding: '0px', // Add your desired padding
                    },
                    // border: `3px solid ${setup !== undefined || label !== undefined ? "transparent" : theme.palette.primaryRowClr.secondary}`
                    outline: "none"
                }}
                autoComplete="off"
                className="smaller-textfield"
                id='treeDrp'
                disabled={disabled}
                inputRef={textFieldRef}
                variant="outlined"
                value={checkedLabel}
                onClick={handleClick}
                fullWidth
                openOnFocus
                onFocus={(e) => {
                    // setAnchorEl(e.currentTarget)
                }}
                onKeyDown={(e) => {
                    const warMsg = "";
                    const name = "";
                    const currentId = "treeDrp";
                    const nextId = "unit";
                    const prevID = "itemName";
                    const required = false;

                    handleAutoCompleteKeyDown(
                        e,
                        name,
                        currentId,
                        nextId,
                        required,
                        warMsg,
                        prevID
                    );
                    if (e.key == "ArrowDown") {
                        handleClick(e)
                    }
                    if (e.key == "Tab" && !document.activeElement.id == "test") {
                        handleClose()
                    }
                }}
                // size={params == undefined ? 'small' : 'medium'}
                size='small'
                label={setup !== undefined || label !== undefined ? "Under Category" : ''}
                InputLabelProps={{
                    shrink: checkedLabel !== ""
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end" sx={{ pr: "10px", cursor: "pointer" }}>
                            <ArrowDropDownIcon />
                        </InputAdornment>
                    )
                }}
            />
            <Popover
                id="tree-popover"
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                sx={{
                    maxHeight: "350px",
                    // minHeight: "100px"
                }}
                onKeyDown={(e) => {
                    if (e.key == "Tab") {
                        e.preventDefault()
                        handleClose()
                        setTimeout(() => {
                            document.getElementById("unite")?.focus()
                        }, 10);
                    }

                }}
            >
                <Box>
                    {/* <TextField
                        value={searchTerm}
                        placeholder="Search"
                        onChange={handleSearchChange}
                        autoFocus
                        size='small'
                        sx={{ width: "100%" }}
                    /> */}
                    {nonTreeData?.length > 5 &&
                        <TextField
                            id='searchCaegory'
                            ref={textfieldInRef}
                            inputRef={textfieldInRef}
                            value={searchTerm}
                            placeholder="Search"
                            onChange={handleSearchChange}
                            autoFocus={openPopover}
                            size="small"
                            sx={{
                                width: '100%',
                                height: "30px",
                                border:"none !important",
                                borderBottom: "1px solid",
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        border: 'none', // Remove the default border
                                    },
                                    '&:hover fieldset': {
                                        border: 'none', // Remove the hover border
                                    },
                                    '&.Mui-focused fieldset': {
                                        border: 'none', // Remove the focus border
                                    },
                                    '&:before': {
                                        borderBottom: '2px solid #000', // Add the bottom border
                                    },
                                    '&:after': {
                                        borderBottom: '2px solid #000', // Add the bottom border on focus
                                    },
                                },
                                '& .MuiInputBase-root': {
                                    '&:before': {
                                        borderBottom: '2px solid #000', // Add the bottom border
                                    },
                                    '&:after': {
                                        borderBottom: '2px solid #000', // Add the bottom border on focus
                                    },
                                },
                            }}
                            onKeyDown={(e) => {
                                if (e.key == "ArrowDown") {
                                    document.getElementById("test")?.focus()
                                }
                                if (e.key == "Tab") {
                                    e.preventDefault()
                                    handleClose()
                                    setTimeout(() => {
                                        document.getElementById("unite")?.focus()
                                    }, 10);
                                }
                            }}
                        />}
                </Box>
                <Box sx={{ maxHeight: "200px", minHeight: "50px", overflowY: 'auto', minWidth: '175px', }}>
                    {searchTerm == "" ?
                        <>
                            {data?.length == 0 ? (<Typography variant="body1" sx={{ pl: 2, pt: 1 }}>
                                No options
                            </Typography>) :
                                <>
                                    <SimpleTreeView
                                        aria-label="customized"
                                        // defaultExpandedItems={[data?.[0]?.value?.[1]]}
                                        defaultExpandedItems={expandIds}
                                        slots={{
                                            expandIcon: CustomExpandIcon,
                                            collapseIcon: CustomCollapseIcon,
                                            // endIcon: CustomEndIcon,
                                        }}
                                        sx={{
                                            overflow: 'hidden', minHeight: 50,
                                            flexGrow: 1, maxWidth: 300,
                                        }}
                                    >
                                        {data?.map((item) => (
                                            <RecursiveListItem
                                                key={item.value[1]}
                                                item={item}
                                                searchTerm={searchTerm}
                                                onCheck={handleCheck}
                                                checked={checkedLabel}
                                                edit={parentDetails?.todo}
                                                setExpandIds={setExpandIds}
                                            />
                                        ))}
                                    </SimpleTreeView>
                                </>
                            }

                        </>
                        :
                        <Box minHeight={"200px"}>
                            <List sx={{ height: "30px" }}>
                                {nonTreeData?.length == 0 ? (<Typography variant="body1" sx={{ pl: 2, pt: 1 }}>
                                    No options
                                </Typography>) :

                                    nonTreeData?.filter((item) => item.label.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0).length == 0 ? (
                                        <Typography variant="body1" sx={{ pl: 2, pt: 1 }}>
                                            No options
                                        </Typography>
                                    ) :
                                        nonTreeData?.filter((item) => (item.label.toLowerCase().indexOf(searchTerm)) >= 0)?.map((item) => {
                                            return (
                                                <ListItem sx={{ mt: 0, mb: 0, pt: 0, pb: 0, p: 0, pl: 2, }} key={item.id}>
                                                    <Checkbox sx={{ fontSize: "10px", padding: "2px", }}
                                                        checked={checkedLabel == item.label}
                                                        onChange={(e) => {
                                                            handleCheckItems(e, item);
                                                        }}
                                                    />
                                                    <Typography variant="body1"
                                                        onClick={(e) => {
                                                            handleCheckItems(e, item);
                                                        }}
                                                    >{item.label}</Typography>
                                                </ListItem>
                                            );
                                        })}
                            </List>
                        </Box>
                    }
                </Box>
                <Box sx={{ boxShadow: '0px -4px 10px -2px rgba(0, 0, 0, 0.2)', width: "100%" }}>
                    {setup === undefined && (
                        <Button
                            sx={{ whiteSpace: "nowrap", m: 0 }}
                            startIcon={<BuildCircle />}
                            onClick={() => {
                                // setPrtDetails()
                                setCategoryDeleteModal(true)
                            }}
                        >
                            {/* Category Setup */}
                            Add Category
                        </Button>
                    )}
                </Box>
            </Popover>

            {deleteCategoryModal == true ?
                <DeleteCategoryModal
                    setState={setState}
                    open={deleteCategoryModal}
                    setOpen={setCategoryDeleteModal}
                    setrow={setrow}
                    categoryArr={categoryArr}
                    setCategoryModal={setCategoryModal}
                    listCategory={getCategory}
                />
                : null}
            <AddCategory
                MainParent={MainParent}
                params={params}
                setCheckedLabel={setPrtDetails}
                setStateS={setState}
                open={categoryModal}
                setOpen={setCategoryModal}
                listCategory={getCategory}
                dataArr={dataArr}
                setCategoryData={setCategoryData}
            />
        </div>
    );
};

export default TreeDropdown;
